import type { DocumentsSchemaType } from './formConfig';

import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/router';
import { useMutation } from 'react-query';

import { documentsSchema } from './formConfig';

import useCurrentUser from '$/hooks/useCurrentUser';
import { useFormWithState } from '$/hooks/useFormWithState';
import handleCommonToast from '$/utils/handleCommonToast';

const useAddDocuments = () => {
  const { userQuery } = useCurrentUser();
  const router = useRouter();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useFormWithState<DocumentsSchemaType>({
    formName: 'AddDocuments',
    mode: 'onChange',
    resolver: yupResolver(documentsSchema),
  });

  const onSubmit = async (data: DocumentsSchemaType) => {
    await router.push('/add-documents/success');
    await userQuery.refetch();
  };

  const submitMutation = useMutation(onSubmit, {
    onError: (error: any) =>
      handleCommonToast('error', error?.code || error, {}, error),
  });

  return {
    form: { control, handleSubmit, formState: { isValid } },
    submitMutation,
    // documents,
  };
};

export default useAddDocuments;
